@use 'styles/mixins';
@use 'styles/variables';

.StatusWrapper {
  @include mixins.flex-align-center;

  &_Icon {
    margin-right: 0.5rem;
  }
}

.Link {
  padding: 0.8rem 2.1rem;

  color: variables.$blue-primary;
  font-size: 1.5rem;

  cursor: pointer;
}
